<template>
  <v-container grid-list-xl text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1>
        <v-card>
          <v-form ref="eventForm" v-model="valid">

            <v-card-title class="headline font-weight-regular primary white--text" primary-title>
              {{(event.name.length > 2) ? event.name : 'Event' }} - Details
            </v-card-title>

            <v-container>
              <v-layout row wrap>

                <!-- Event Name -->
                <v-flex xs10 offset-xs1>
                  <v-text-field 
                    v-model="event.name" 
                    label="Name" 
                    hint="What's the name of your event?"
                    persistent-hint
                    clearable 
                    prepend-icon="event_note"
                    :rules="eventNameRules"></v-text-field>
                </v-flex>

                <!-- Start Date -->
                <v-flex xs10 offset-xs1>
                  <v-menu
                    ref="datePicker"
                    v-model="showDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="event.date"
                    lazy offset-y
                    full-width min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedStartDate"
                      label="Start Date"
                      hint="What date is your event on?"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="event.date" @input="$refs.datePicker.save(event.date)"></v-date-picker>
                  </v-menu>
                </v-flex>

                <!-- Event Start Time -->
                <v-flex xs10 offset-xs1>
                  <v-dialog
                    ref="eventStartTime"
                    v-model="showStartTimePicker"
                    :return-value.sync="event.startTime"
                    lazy full-width width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Start Time"
                      hint="What time is your event starting at?"
                      pesistent-hint
                      v-model="formattedStartTime"
                      prepend-icon="access_time"
                      readonly
                    ></v-text-field>
                    <v-time-picker v-model="event.startTime" full-width>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="showStartTimePicker = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.eventStartTime.save(event.startTime)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>

                <!-- Event end date--> 
                <v-flex xs10 offset-xs1>
                  <v-menu
                    ref="endDatePicker"
                    v-model="showEndDatePicker"
                    lazy
                    :close-on-content-click="false"
                    :return-value.sync="event.endDate"
                    offset-y
                    full-width min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedEndDate"
                      label="End Date"
                      hint="What date does your event end?"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="event.endDate" @input="$refs.endDatePicker.save(event.endDate)"></v-date-picker>
                  </v-menu>
                </v-flex>

                <!-- Event End Time -->
                <v-flex xs10 offset-xs1>
                  <v-dialog
                    ref="eventEndTime"
                    v-model="showStopTimePicker"
                    :return-value.sync="event.endTime"
                    lazy full-width width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedEndTime"
                      label="End Time"
                      hint="What time does your event end at?"
                      persistent-hint
                      prepend-icon="access_time"
                      readonly
                    ></v-text-field>
                    <v-time-picker v-model="event.endTime" full-width>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="showStopTimePicker = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.eventEndTime.save(event.endTime)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>

                <!-- Event Location -->
                <v-flex xs10 offset-xs1>
                  <Autocomplete id="event-name" v-on:placechanged="setEventLocation"
                     required></Autocomplete>
                </v-flex>

                <!-- <v-flex xs10 offset-xs1>
                  <Suggestions v-on:suggestionsupdated="setSuggestionLocations"></Suggestions>
                </v-flex> -->

                <!-- Event Map -->
                <v-flex xs12 sm10 offset-sm1>
                    <Mapbox name="map">
                      <MapboxMarkers v-if="eventLocationIsSet" :locs="eventPlace"></MapboxMarkers>
                    </Mapbox>
                    <!--   <Gmap name="map">
                      <GMapMarker v-if="eventLocationIsSet" :locs="eventPlace"></GMapMarker>
                    </Gmap> -->
                </v-flex>

                <!-- Event Type -->
                <v-flex xs12 sm3>
                  <v-subheader>Event Type</v-subheader>
                </v-flex>

                <v-flex xs10 sm8 offset-xs1 offset-sm0>
                  <v-radio-group v-model="event.type" row>
                    <v-radio color="primary" label="Public" value="public"></v-radio>
                    <v-radio color="primary" label="Private" value="private"></v-radio>
                  </v-radio-group>
                  <p class="text-xs-left">{{event.type == 'public' ? 'This event\'s page can be shared with a link! All information entered will be visible to those with the link.' : 'This event is only visible to you. People, even with the link, should not be able to view details.'}}</p>
                </v-flex>

                <!-- Event Attendees -->
                <v-flex xs10 offset-xs1 v-if="event.type == 'private'">
                  <v-combobox
                    v-model="attendeeEmails"
                    :search-input.sync="attendeeSearch"
                    hide-selected
                    hint="Max of 5 emails"
                    label="Add some attendees"
                    multiple
                    persistent-hint
                    small-chips
                  >
                   <template slot="no-data">
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          Press enter to add "<strong>{{attendeeSearch}}</strong>" to the list of attendees
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                   </template>

                  </v-combobox>
                </v-flex>
          
                <v-flex xs12 sm5 offset-sm7 text-sm-right>
                  <v-spacer></v-spacer>
                  <v-btn flat @click="cancel()">Cancel</v-btn>
                  <!-- <v-btn flat @click="clear()">Clear</v-btn> -->
                  <v-btn flat @click="save()">Save</v-btn>
                </v-flex>
              </v-layout>
            </v-container>

          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Mapbox from '../components/Mapbox';
  import MapboxMarkers from '../components/MapboxMarkers'
  import Autocomplete from '../components/Autocomplete'
  // import Gmap from '@/components/Gmap'
  // import GMapMarker from '@/components/GMapMarker'

  import { eventBus } from '../main'

  import uuidv4 from 'uuid/v4'

  export default {
    name: 'event',
    data(){
      return{
        event: {
          id: uuidv4(),
          name: '', 
          start: null,
          date: null, 
          startTime: null, 
          endDate: null,
          endTime: null,
          end: null,
          location: {}, 
          owner: {}, 
          type: 'private', 
          attendeeEmails: [], 
          locations: []
        }, 
        valid: true,
        clearMarkers: false,
        eventLocationIsSet: false,
        showDatePicker: false, 
        
        formattedStartDate: null,
        showStartTimePicker: false, 
        formattedStartTime: null, 

        showEndDatePicker: false,
        formattedEndDate: null,
        showStopTimePicker: false,
        formattedEndTime: null,
        
        snackbar: {
          text: '',
          color: '', 
        },
        eventNameRules: [
          v => !!v || 'Event Name is required', 
          v => (v && v.length >= 3) || 'Name must be at least 3 characters'
        ],
        eventPlace: [],
        
        // Email Autocomplete things
        attendeeEmails: [],
        attendeeSearch: null

      }
    }, 
    components:{
      Mapbox, MapboxMarkers, Autocomplete
    },
    mounted: function() {
      if(typeof this.$route.params.id != "undefined") {
        let eventId = this.$route.params.id

        this.$store.commit('events/SET_ROUTED_EVENTID', eventId);
        let routedEvent = this.$store.getters['events/getEventById']
      }
    }, 
    created: function(){

    },
    methods: {
      cancel () {
        this.$router.go(-1);
      }, 
      formatDate (date) {
        if (!date) return null;

        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
      },
      formatTime (time){
        if (!time) return null

        const [hour, minute] = time.split(':')
        return `${(parseInt(hour,10)%12)}:${minute} ${(parseInt(hour,10) > 12) ? 'PM' : 'AM'}`
      },
      save() {

        if(this.event.type == 'private'){
          this.event.attendeeEmails = this.attendeeEmails 
        } 

        this.$store.dispatch('events/addEvent', this.event)

        this.snackbar.text = 'Your event: \'' + this.event.name + '\' was saved!';
        this.snackbar.color = 'success'

        eventBus.$emit('snackAlert', this.snackbar);


        setTimeout(() => { 
          this.$router.push({path: `/event/${this.event.id}`})
        }, 3500);

        this.clear();
      }, 
      setEventLocation (formattedPlace, rawPlace){
        this.event.location.address = rawPlace.formatted_address;
        this.event.location.geometry = rawPlace.geometry.location;

        this.eventPlace.push(rawPlace);
        this.eventLocationIsSet = true;
      }, 
      clear (){
        // This breaks the autocomplete at this point... and I'm not sure why... 
        // this.$refs.eventForm.reset()
        this.event.name = ''
        this.event.location = ''
        this.event.date = null
        this.event.start = null
        this.event.end = null
      },
      setSuggestionLocations (suggestionLocations){
        this.event.locations = suggestionLocations
      }
      // Email autocomplete functions
    }, 
    computed: {
      today (){
        const day = new Date()
        return day.getFullYear() + '-' + (day.getMonth()+1) + '-' + day.getDate()
      }, 
      date (){
        return this.event.date
      }, 
      endDate (){
        return this.event.endDate
      }, 
      startTime (){
        return this.event.startTime
      }, 
      endTime (){
        return this.event.endTime
      }
    }, 
    watch: {
      date (val) {
        this.formattedStartDate = this.formatDate(this.event.date)
      },
      endDate (val) {
        this.formattedEndDate  = this.formatDate(this.event.endDate)
      },
      startTime (val) {
        this.formattedStartTime = this.formatTime(this.event.startTime)
      }, 
      endTime (val) {
        this.formattedEndTime = this.formatTime(this.event.endTime)
      },
      
      // For email address autocomplete
      attendeeEmails(val, prev){
        const validEmailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

        //Prevent an infinite loop.. if the length of old value = new value, then break out
        if(val.length === prev.length) return 

        // If there's more than 5 items being inputted, then pop the last item (we are maxing out at 5)
        if(val.length > 5) {
          this.$nextTick(() => this.attendeeEmails.pop())
        } 
        // If there's less than 5 items, then check the last item inputted was a valid email... if it's not then pop up after adding it
        else if(val.length <= 5){
          var mostRecentInput = val[val.length-1]

          if(!validEmailRegex.test(mostRecentInput)){
            this.$nextTick(() => this.attendeeEmails.pop())
          }
        }
      }
    }
  }
</script>
<style>
.text-center{
    text-align: center;
  }


</style>
